// extracted by mini-css-extract-plugin
export default {"container":"Consents_container__Qid2y","consentsContainer":"Consents_consentsContainer__lVoOx","title":"Consents_title__r2HmG"};